;(function(){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['bank_account', 'merchant_services'],
    data: function data() {
        return {
            services: [],
            account: {},
            selectedServices: [],
            searchText: ""
        };
    },
    computed: {
        filteredServices: function filteredServices() {
            var _this = this;

            var services = this.services;
            if (this.searchText) {
                services = services.filter(function (service) {
                    return service.name.toLowerCase().includes(_this.searchText.toLowerCase());
                });
            }
            return services;
        }
    },
    mounted: function mounted() {
        this.account = JSON.parse(this.bank_account);
        this.services = JSON.parse(this.merchant_services);
        this.check_selected();
    },
    methods: {
        check_selected: function check_selected() {
            for (var i = 0; i < this.account.service_bank_accounts.length; i++) {
                this.selectedServices.push(this.account.service_bank_accounts[i].service_id);
            }
        },
        check_if_selected: function check_if_selected(service_id) {
            return this.selectedServices.includes(service_id);
        },
        selectAll: function selectAll() {
            this.selectedServices = [];
            for (var i = 0; i < this.filteredServices.length; i++) {
                this.selectedServices.push(this.filteredServices[i].id);
            }
        },
        deselectAll: function deselectAll() {
            this.selectedServices = [];
            this.searchText = "";
        },
        selectItem: function selectItem() {
            this.selectedServices = [];
            for (var i = 0; i < this.filteredServices.length; i++) {
                if (document.getElementById(this.filteredServices[i].id).checked) {
                    this.selectedServices.push(this.filteredServices[i].id);
                }
            }
        },
        configure_bank_services: function configure_bank_services() {
            var save_url = "/api/bank/account/services";
            Vue.axios.post(save_url, {
                service_ids: this.selectedServices,
                account_id: this.account.id
            }).then(function (response) {
                if (response.data.status === 200) {
                    $("#addServiceBank").modal('hide');
                    window.location.reload();
                } else {
                    alert("Something went wrong");
                }
            }).catch(function (error) {
                alert("Something went wrong");
            });
        }
    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"addServiceBank","tabindex":"-1","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Configure Services for "+_vm._s(_vm.account.name))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"md-form"},[_c('form',{attrs:{"method":"POST"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"row align-item-center mb-3"},[_c('div',{staticClass:"col-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Search items"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}})]),_vm._v(" "),(_vm.selectedServices.length < 1)?_c('div',{staticClass:"col-2"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.filteredServices.length},on:{"click":_vm.selectAll}},[_vm._v("Select All")])]):_c('div',{staticClass:"col-2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.deselectAll}},[_vm._v("Clear")])])]),_vm._v(" "),_vm._l((_vm.filteredServices),function(service){return _c('div',{key:service.id,staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedServices),expression:"selectedServices"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":service.id},domProps:{"checked":_vm.check_if_selected(service.id),"value":service.id,"checked":Array.isArray(_vm.selectedServices)?_vm._i(_vm.selectedServices,service.id)>-1:(_vm.selectedServices)},on:{"change":[function($event){var $$a=_vm.selectedServices,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=service.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedServices=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedServices=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedServices=$$c}},_vm.selectItem]}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":service.id}},[_vm._v("\n                                "+_vm._s(service.name)+"\n                            ")])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.selectedServices.length},on:{"click":_vm.configure_bank_services}},[_vm._v("Save changes")])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-53972842", __vue__options__)
  } else {
    hotAPI.reload("data-v-53972842", __vue__options__)
  }
})()}